import React from "react";
import { useNavigate } from "react-router-dom";
import AppFooter from "../components/AppFooter";
import {
  ArrowLeft,
  ShieldCheck,
  Lock,
  User,
  MessageSquare,
  Smartphone,
} from "lucide-react";

const PrivacyNotice = () => {
  const navigate = useNavigate();

    const sections = [
    {
      icon: <Lock className="w-6 h-6 text-cyan-200" />,
      title: "Privacy Notice",
      content: [
        `You must be at least 18 years of age to use AICA HEALTH Services. Caregivers who are at least 18 years old may create an account on behalf of a minor, but minors may not independently use AICA HEALTH services.`,

        `Users may not misuse AICA HEALTH services or applications owned by AICA HEALTH TECH Pvt Ltd. Posting or transmitting illegal, obscene, threatening, defamatory, harmful, privacy-invasive, or spam-related content is strictly prohibited.`,

        `AICA HEALTH services and applications may only be used in compliance with applicable laws. Any violation of these terms may result in suspension or termination of access and licenses granted by AICA HEALTH TECH Pvt Ltd.`,
      ],
    },

    {
      icon: <User className="w-6 h-6 text-emerald-200" />,
      title: "Your Account",
      content: [
        `Certain services require an active AICA HEALTH account and a valid payment method. Users agree to maintain accurate, current, and complete account information.`,

        `You are responsible for maintaining the confidentiality of your account credentials and all activities performed under your account.`,

        `AICA HEALTH reserves the right to suspend, terminate, or restrict accounts and services at its sole discretion, including the removal or modification of content.`,
      ],
    },

    {
      icon: <MessageSquare className="w-6 h-6 text-pink-200" />,
      title: "Communications with AICA",
      content: [
        `By using AICA HEALTH services, you consent to receive electronic communications including emails, text messages, notifications, and account-related alerts.`,

        `These communications may include information regarding prescriptions, healthcare services, treatment updates, benefits, or reminders.`,

        `If you share your mobile device, email account, or AICA HEALTH account access with others, they may also have visibility into this information.`,
      ],
    },

    {
      icon: <Smartphone className="w-6 h-6 text-indigo-200" />,
      title: "App Permissions",
      content: [
        `Applications created and owned by AICA HEALTH TECH Pvt Ltd may request device permissions to improve functionality and user experience.`,

        `Users can manage, modify, or revoke permissions anytime through their device settings.`,
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-cyan-200/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-blue-300/30 rounded-full blur-3xl"></div>

      {/* Main Container */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-10">

          <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/80 border border-cyan-200 backdrop-blur-xl text-sm text-cyan-700 shadow-lg">
            AICA HEALTH POLICY
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-slate-800">
            Privacy Notice
          </h1>

          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Transparent and customer-friendly refund guidelines for all AICA
            subscriptions, services, and healthcare platform operations.
          </p>
        </div>

        {/* Policy Cards */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-3xl border border-white/60 bg-white/70 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >

              {/* Glass Shine */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none"></div>

              <div className="relative z-10">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 text-slate-800">
                  {sec.title}
                </h2>

                <p className="text-slate-600 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                  {sec.content}
                </p>
              </div>

            </div>
          ))}

        </div>

        {/* Footer */}
       <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
                </div>

      </div>
       {/* <AppFooter /> */}
    </div>
  );
};

export default PrivacyNotice;